var _g, _g2, _g3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgShowPasswordIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    fill: "#000000",
    width: "800px",
    height: "800px",
    viewBox: "0 0 256 256",
    id: "Flat",
    xmlns: "http://www.w3.org/2000/svg",
    stroke: "#000000",
    strokeWidth: 1.28,
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "SVGRepo_bgCarrier",
    strokeWidth: 0
  })), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    id: "SVGRepo_tracerCarrier",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    id: "SVGRepo_iconCarrier"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M250.96582,123.12659c-.36328-.81836-9.127-20.26075-28.48047-39.61524C196.63477,57.65686,163.96191,43.99182,128,43.99182s-68.63477,13.665-94.48535,39.51953C14.16113,102.86584,5.39746,122.30823,5.03418,123.12659a12.00024,12.00024,0,0,0,0,9.74707c.36426.81836,9.12793,20.25683,28.48145,39.60742C59.36621,198.32971,92.03809,211.99182,128,211.99182s68.63379-13.66211,94.48438-39.51074c19.35351-19.35059,28.11718-38.78906,28.48144-39.60742A12.00024,12.00024,0,0,0,250.96582,123.12659ZM204.91406,156.107C183.46582,177.26428,157.58789,187.99182,128,187.99182S72.53418,177.26428,51.08594,156.107A130.50586,130.50586,0,0,1,29.5166,127.99963,130.53626,130.53626,0,0,1,51.08691,99.88342C72.53516,78.72131,98.41211,67.99182,128,67.99182s55.46484,10.72949,76.91309,31.8916a130.549,130.549,0,0,1,21.57031,28.11426A130.47521,130.47521,0,0,1,204.91406,156.107ZM128,83.99963a44,44,0,1,0,44,44A44.04978,44.04978,0,0,0,128,83.99963Zm0,64a20,20,0,1,1,20-20A20.02229,20.02229,0,0,1,128,147.99963Z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgShowPasswordIcon);
export default __webpack_public_path__ + "static/media/show-password-icon.a0ca9d25422776b205a38bd974f0f687.svg";
export { ForwardRef as ReactComponent };